export * from "./link-app"
export * from "./app-list"
export * from "./app-config"
export * from "./gate-config"

export const ACTION_LINK_APP = "LINK_APP"
export const ACTION_UNLINK_APP = "UNLINK_APP"

export const ACTION_GET_LIST_APPS = "GET_LIST_APPS";
export const ACTION_GET_LIST_APPS_SUCCESS = "GET_LIST_APPS_SUCCESS";
export const ACTION_GET_LIST_APPS_ERROR = "GET_LIST_APPS_ERROR";

export const ACTION_GET_CONFIG = "GET_APP_CONFIG";
export const ACTION_GET_CONFIG_SUCCESS = "GET_APP_CONFIG_SUCCESS";
export const ACTION_GET_CONFIG_ERROR = "GET_APP_CONFIG_ERROR";

export const ACTION_GET_GATE_CONFIG = "GET_GATE_CONFIG";
export const ACTION_GET_GATE_CONFIG_SUCCESS = "GET_GATE_CONFIG_SUCCESS";
export const ACTION_GET_GATE_CONFIG_ERROR = "GET_GATE_CONFIG_ERROR";